export const testimonials = [
  {
    id: 1,
    name: '张明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%20headshot%20with%20warm%20friendly%20smile%20on%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20look&width=80&height=80&seq=avatar-1&orientation=squarish',
    position: 'IT项目经理',
    content: '通过成人高考获得了计算机本科学历，现在终于突破了职业发展的天花板。从报名到毕业，整个流程都很顺利，老师们的辅导非常用心。学历提升后，薪资翻了一倍，真心感谢这个平台！',
    rating: 5,
  },
  {
    id: 2,
    name: '李芳',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%20headshot%20with%20confident%20warm%20smile%20on%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-2&orientation=squarish',
    position: '人力资源主管',
    content: '在带孩子的同时完成了自学考试的全部课程，拿到本科学位的那一刻真的特别激动。学习过程虽然辛苦，但收获远超预期。现在在公司更有底气了，也给孩子树立了好榜样。',
    rating: 5,
  },
  {
    id: 3,
    name: '王建国',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20professional%20portrait%20headshot%20with%20kind%20smile%20on%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting%2C%20business%20casual&width=80&height=80&seq=avatar-3&orientation=squarish',
    position: '销售总监',
    content: '42岁选择网上教育提升学历，很多人说我疯了。但我坚信学习永远不晚。网络教育灵活的学习方式让我可以边工作边学习，两年半顺利完成学业。事实证明，投资自己永远是最值得的。',
    rating: 5,
  },
  {
    id: 4,
    name: '陈晓燕',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20professional%20portrait%20headshot%20with%20bright%20genuine%20smile%20on%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting%2C%20modern%20look&width=80&height=80&seq=avatar-4&orientation=squarish',
    position: '行政经理',
    content: '通过国家开放大学拿到了行政管理本科学历，从普通文员晋升为行政经理。感谢平台的老师们一路指导和鼓励。学历提升带给我的不仅是职位和薪资的变化，更是整个人的自信和成长。',
    rating: 5,
  },
  {
    id: 5,
    name: '刘伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20in%20his%2030s%20portrait%20headshot%20with%20friendly%20smile%20on%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-5&orientation=squarish',
    position: '建筑工程师',
    content: '成人高考土木工程专业毕业，考上了一级建造师。学历这个门槛过去一直是我的心结，现在终于解开了。平台的课程质量很高，高清视频看得特别清楚，比想象中效果好太多了。',
    rating: 5,
  },
  {
    id: 6,
    name: '赵雪梅',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20woman%20professional%20portrait%20headshot%20with%20warm%20elegant%20smile%20on%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-6&orientation=squarish',
    position: '幼儿园园长',
    content: '通过自学考试获得了学前教育本科学历，实现了从老师到园长的跨越。自考的过程锻炼了我的自律能力和学习能力，这种内在收获甚至比学历本身更有价值。',
    rating: 5,
  },
];